import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import {
  customerAddProxy
} from '../../../../../shared/components/CustomerAddSlideOver/customerAddProxy'
import { populateCustomerInformationForEdit } from '../modals/utils'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../shared/utils/gtmUtils'

const handleButtonClick = (): void => {
  populateCustomerInformationForEdit()
  customerAddProxy.displaySlideOver = true
  gtmTrackButtonPress(GtagEvents.CUSTOMER_MODAL_OPEN)
}
export function CustomerEditModalOpenButton (): ReactElement {
  const { siteTheme } = useSnapshot(proxyGlobalAuth)

  return (
    <button
      onClick={handleButtonClick}
      className={cn(
        siteTheme.buttonColors.classes,
        'rounded py-2 px-4 text-white cursor-pointer'
      )}
    >
      Edit Customer
    </button>
  )
}
